import { useTranslations } from 'next-intl';

import { DayOfWeek, ShopWorkTime } from '@/api/backend/contract/Shop';
import { UiKitButton } from '@/ui-kit/button';
import { DELIVERY_DATE_TODAY_KEY } from '@/util/format-delivery-date';
import { utilFormatPhoneNumber } from '@/util/format-phone-number';
import { PointFeature } from '@/util/map-point-maps/types';

import { styles } from './UiPickupPointInfo.styles';

export interface UiPickupPointInfoProps {
  point: PointFeature;
  activePointId: string | null;
  onPointConfirm: (pointId: string) => void;
  hideConfirmButton?: boolean;
  isFreeShipping?: boolean;
}

export function UiPickupPointInfo({
  point,
  activePointId,
  onPointConfirm,
  hideConfirmButton
}: UiPickupPointInfoProps) {
  const t = useTranslations();
  const tDays = useTranslations('daysOfWeek');

  const slots = styles();

  if (!point.properties || !('pointType' in point.properties)) {
    return;
  }

  return (
    <>
      {point.properties.carrierName && (
        <div className={slots.pointTitle()}>{point.properties.carrierName}</div>
      )}
      <div className={slots.pointAddress()}>{point.properties.street}</div>
      <div className={slots.pointCost({ accent: point.properties.cost <= 1 })}>
        {t('cost')}: {point.properties.cost <= 1 ? '1 ₽' : `${point.properties.cost} ₽`}
      </div>
      {point.properties.deliveryDate && (
        <div
          className={slots.pointDeliveryDate({
            accent: point.properties.deliveryDate === DELIVERY_DATE_TODAY_KEY
          })}
        >
          {t('deliveryDate')} —{' '}
          {point.properties.deliveryDate === DELIVERY_DATE_TODAY_KEY
            ? t('today')
            : point.properties.deliveryDate}
        </div>
      )}
      {activePointId === point.id && (
        <>
          {point.properties.phone && (
            <>
              <div className={slots.pointHeading()}>{t('phone')}</div>
              <div className={slots.pointValue()}>
                {utilFormatPhoneNumber(point.properties.phone)}
              </div>
            </>
          )}

          {point.properties.openingHours.length > 0 && (
            <>
              <div className={slots.pointHeading()}>{t('openingHours')}</div>
              <div className={slots.pointValue()}>
                {Array.isArray(point.properties.openingHours) &&
                  point.properties.openingHours.length > 0 &&
                  (typeof point.properties.openingHours[0] === 'string'
                    ? point.properties.openingHours.map((hour, index) =>
                        typeof hour === 'string' ? <div key={index}>{hour}</div> : null
                      )
                    : (point.properties.openingHours as ShopWorkTime[]).map((wt) => (
                        <div key={wt.id}>
                          <span>{tDays(wt.day as DayOfWeek)}:</span>{' '}
                          <span>
                            {wt.startTime} – {wt.endTime}
                          </span>
                        </div>
                      )))}
              </div>
            </>
          )}
          {!hideConfirmButton && (
            <div className={slots.pointConfirm()}>
              <UiKitButton
                className={slots.pointConfirmBtn()}
                onClick={() => onPointConfirm(point.id)}
              >
                {t('Select')}
              </UiKitButton>
            </div>
          )}
        </>
      )}
    </>
  );
}
